import { Component, OnInit } from '@angular/core';
import { RoleDto } from 'src/app/models/RoleDto';
import { RolesService } from 'src/app/services/roles.service';

@Component({
  selector: 'app-view-roles',
  templateUrl: './view-roles.component.html',
  styleUrls: ['./view-roles.component.css']
})
export class ViewRolesComponent implements OnInit {
  Roles:RoleDto[]=[];
  constructor(private roleService:RolesService) { }
 
  ngOnInit(): void {
    this.loadRecords()
  }

  async  loadRecords()
  {
    
    let  resRoles = await this.roleService.getRoles().toPromise(); 
    this.Roles = <RoleDto[]> resRoles.responseData;

  }

}
